import { useEffect, useState } from 'react';
import { Engine, HistoricDataTotal } from '../../../../../api/types';
import useSWR from 'swr';
import urls from '../../../../../api/urls';
import { api } from '../../../../../api/apiProvider';
import { Dayjs } from 'dayjs';

const dateFormat = 'YYYY-MM-DD';

export interface DataTotalsFilter {
  channels: number[];
  factors: number[];
  startDate?: string;
  endDate?: string;
}

export type HistoricDataDateRange = {
  dateStart: Dayjs,
  dateEnd: Dayjs,
} | null | undefined;

export default function useHistoricDataTotal (
  engine: Engine | null,
  filter: DataTotalsFilter,
  dateRange: HistoricDataDateRange,
) {
  const [historicDataTotal, setHistoricDataTotal] = useState<HistoricDataTotal>();

  const getHistoricDataTotalsParams = () => {
    const params = new URLSearchParams([
      ['t[]', 'factor'], ['t[]', 'channel'],
      ['t[]', 'dataChannel'], ['t[]', 'data:metrics'],
      ['t[]', 'data'],
    ]);

    if (filter.channels) {
      for (let channelId of filter.channels) {
        params.append('filterComponents[channels][]', String(channelId));
      }
    }

    if (filter.factors) {
      for (let factorId of filter.factors) {
        params.append('filterComponents[factors][]', String(factorId));
      }
    }

    if (dateRange) {
      params.append('dateStart', dateRange.dateStart.format(dateFormat));
      params.append('dateEnd', dateRange.dateEnd.format(dateFormat));
    }

    return params.toString();
  };

  const {
    data: historicDataTotalData,
    isValidating: isHistoricDataTotalLoading,
    mutate: mutateHistoricDataTotal,
  } = useSWR<{
    data: HistoricDataTotal,
  }>(engine && engine.id > 0 && dateRange !== undefined ? `${urls.engines}/${engine.id}/historic_data_total?${getHistoricDataTotalsParams()}` : null, api.get, {
    revalidateOnFocus: false,
  });

  useEffect(() => {
    if (historicDataTotalData && historicDataTotalData.data) {
      setHistoricDataTotal(historicDataTotalData.data);
    }
  }, [historicDataTotalData]);

  return ({
    historicDataTotal,
    isHistoricDataTotalLoading,
    mutateHistoricDataTotal,
  });
}
